<button
  (click)="onClick($event)"
  *ngIf="!measurmentButton"
  [class.bg-accent-700]="onOff"
  [class.mobile]="isMobile"
  [disabled]="disabled"
  [matTooltipPosition]="hintPosition"
  [matTooltip]="hint"
  class="controls-icons"
  mat-menu-item
>
  <ng-container *ngIf="innerIcon">
    <mat-icon *ngIf="onOff" [ngClass]="innerIconClass" [svgIcon]="innerIconOff" class="show-hide">
    </mat-icon>
    <mat-icon *ngIf="!onOff" [ngClass]="innerIconClass" [svgIcon]="innerIconOn" class="show-hide">
    </mat-icon>
  </ng-container>
  <mat-icon [class.text-warning]="onOff && !iconClass" [ngClass]="iconClass" [svgIcon]="icon">
  </mat-icon>
  <span class="title"><ng-content></ng-content></span>
</button>
<button
  (click)="onClick($event)"
  *ngIf="measurmentButton"
  [class.bg-accent-700]="onOff"
  [class.mobile]="isMobile"
  [disabled]="disabled"
  [matTooltipPosition]="hintPosition"
  [matTooltip]="hint"
  class="controls-icons"
  mat-menu-item
>
  <mat-icon [class.text-warning]="onOff" [svgIcon]="icon"> </mat-icon>
  <div [ngClass]="getMeasurementStatus()" class="measurement-flag"></div>

  <span class="title"><ng-content></ng-content></span>
</button>
